import { Client } from "./baseurl";

export const getEvents = async(keywords:string | null, date:string | null, provinceId:string | null, placeId:string | null, locationId:string | null, page:number | null) => {
    const request = {
            "keywords":keywords,
            "place":placeId,
            "date":date,
            "provinceId":provinceId,
            "locationId": locationId,
            "page": page,
            "eventHash": null,
            "groupId": null
    }
    const response = await Client.post(`/events`,request);
    return response.data;
}


export const getEventsItemTypeGroup = async(groupId:string) => {
    const request = {
            "keywords":null,
            "place":null,
            "date":null,
            "provinceId":null,
            "locationId": null,
            "eventHash": null,
            "groupId": groupId
    }
    const response = await Client.post(`/events`,request);
    return response.data;
}

export const getEventsItemTypeProducer = async(producerId:string) => {
    const request = {
            "keywords":null,
            "place":null,
            "date":null,
            "provinceId":null,
            "locationId": null,
            "eventHash": null,
            "groupId": null,
            "producerId": producerId
    }
    const response = await Client.post(`/events`,request);
    return response.data;
}

export const getSelectedEvent = async(eventHash:string, vendor?:string) => {
    try {
        const response = await Client.get(`/events/${eventHash}?vendor=${vendor ? vendor : ''}`);
        const userId: string = response.headers['x-ew-ruid'];

        if(response.data.length === 0) {
            const redirect: string = response.headers['x-queueit-redirect'];
            return {data: null, userId: null, redirect: redirect};
        }

        return {data: response.data, userId: userId, redirect: null};
    } catch (error) {
        console.log('Error GetSelectedEvent');
        console.log(error);
        throw error;
    }
}


